<script setup>
import SecondaryButton from "@/Components/Buttons/SecondaryButton.vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { onMounted, ref } from "vue";
import DangerButton from "@/Components/Buttons/DangerButton.vue";

const open = ref(false);

const confirmationText = ref("");
const confirmationCallback = ref(() => {});

onMounted(() => {
    Emitter.on("openConfirmationModal", (parameters) => {
        confirmationText.value = parameters.confirmationText;

        confirmationCallback.value = parameters.callback;
        open.value = true;
    });
});

function handleConfirmClick() {
    open.value = false;
    confirmationCallback.value();
}

const data = ref({
    confirmationCallback: null,
    isOpen: false,
    confirmationText: null,
});
</script>

<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-[70]" @close="open = false">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="relative transform overflow-hidden bg-white rounded-2xl max-w-lg">
                            <div class="sm:flex sm:items-start px-6 py-6">
                                <div
                                    class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                                >
                                    <ExclamationTriangleIcon class="h-6 w-6 text-red-600" aria-hidden="true" />
                                </div>
                                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" class="text-lg font-semibold leading-6 text-gray-900"
                                        >Let op!</DialogTitle
                                    >
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">{{ confirmationText }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="border-t border-stone-100 px-6 py-4 flex items-center justify-end gap-4">
                                <SecondaryButton title="annuleren" @click="open = false"
                                    >{{ __("Cancel") }}
                                </SecondaryButton>
                                <DangerButton @click="handleConfirmClick"> {{ __("Confirm") }} </DangerButton>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
